import { createAsyncThunk } from '@reduxjs/toolkit';
import { SellingCakeReport } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindSellingCakeReport } from './interface';

export const findSellingCakeReport = createAsyncThunk(
  'sellingCakeReport/findSellingCakeReport',
  async (values: FindSellingCakeReport, { rejectWithValue }) => {
    try {
      const response = await SellingCakeReport.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  });